require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./von-dachziegeln-und-fensterscheiben.json") })
        }
      }, "path---von-dachziegeln-und-fensterscheiben");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---von-dachziegeln-und-fensterscheiben!./.cache/json/von-dachziegeln-und-fensterscheiben.json
// module id = 432
// module chunks = 231608221292675